module.exports = __webpack_public_path__ + "static/media/back.535b1942.svg";